import { LinkModel } from './LinkModel';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { P2GAlert, P2GBox } from '@parcel2go/core-ui';

interface props {
  links: LinkModel[];
}

export const AdditionalLinkInfo: React.FC<props> = (props) => {
  const showS17ClarificationMessage =
    SettingsCache.profile.startsWith('EVRI.SME.') &&
    !!props.links.find(
      (x) =>
        x.Type === 'LABELS-A4_DOWNLOAD' ||
        x.Type === 'ORDER-LABELS-A4_DOWNLOAD' ||
        x.Type === 'LABELS-PACKING-A4_DOWNLOAD' ||
        x.Type === 'ORDER-LABELS-PACKING-A4_DOWNLOAD'
    );

  return (
    showS17ClarificationMessage && (
      <P2GBox mt={1}>
        <P2GAlert>
          Choose the <strong>A4 Printer (1 x 4x6 Label)</strong> option for an <strong>S17 integrated label</strong>.
        </P2GAlert>
      </P2GBox>
    )
  );
};
